class StringUtilsService {
  computeStableHash(input) {
    let hash = 2166136261;
    for (let i = 0; i < input.length; i++) {
      hash = Math.imul(hash ^ input.charCodeAt(i), 16777619);
    }
    return (hash >>> 0).toString(36);
  }

  stableStringify(value) {
    const seen = new WeakSet();
    const stringify = (v) => {
      if (v === null || v === undefined) return 'null';
      const t = typeof v;
      if (t === 'string') return JSON.stringify(v);
      if (t === 'number' || t === 'boolean') return String(v);
      if (t !== 'object') return JSON.stringify(String(v));
      if (v instanceof Date) return JSON.stringify(v.toISOString());
      if (seen.has(v)) return '"[Circular]"';
      seen.add(v);
      if (Array.isArray(v)) {
        const res = `[${v.map(stringify).join(',')}]`;
        seen.delete(v);
        return res;
      }
      const keys = Object.keys(v).sort();
      const res = `{${keys.map((k) => `${JSON.stringify(k)}:${stringify(v[k])}`).join(',')}}`;
      seen.delete(v);
      return res;
    };
    return stringify(value);
  }
}

export default StringUtilsService;



// WEBPACK FOOTER //
// ./app/common/stringUtils/stringUtils.service.js